<button id="sc-chatbot-trigger" class="sc-chatbot-trigger" [class.pulse]="isPulsating" [class.slide-in]="show">
  @if (state == 'chat') {
    <svg class="sc-icon-chat" height="31" viewBox="0 0 33 31" width="33" xmlns="http://www.w3.org/2000/svg">
      <path d="m17 28.9v22.1277727c0 .4970563.4029437.9.9.9h4.6v7.0722273l9.625-7.0722273h16.975c.4970563 0 .9-.4029437.9-.9v-22.1277727c0-.4970563-.4029437-.9-.9-.9h-31.2c-.4970563 0-.9.4029437-.9.9z" fill="#fff" transform="translate(-17 -28)" />
    </svg>
  }
  @if (state == 'close') {
    <svg class="sc-icon-close" height="18" viewBox="0 0 19 18" width="19" xmlns="http://www.w3.org/2000/svg">
      <path d="m16.2227629.08899602 2.2482322 2.24823215-6.6335098 6.63276785 6.6335098 6.63327758-2.2482322 2.2482322-6.63327757-6.6335098-6.63276785 6.6335098-2.24823215-2.2482322 6.633-6.63327758-6.633-6.63276785 2.24823215-2.24823215 6.63276785 6.633z" fill="#fff" fill-rule="evenodd" />
    </svg>
  }
  @if (badge > 0) {
    <span id="sc-chat-badge" class="badge">{{ badge }}</span>
  }
</button>